import _ from 'es-toolkit/compat';
import { Workbook } from 'exceljs';

import { FileType } from '@clearverify/constants';
import { flattenObj } from '@clearverify/utils';

import type { DefaultDataRow, TableExcelColumn } from 'src/components/table/types';
import { downloadXlsx } from 'src/utils/file';

export const handleExport = async <TRecord extends DefaultDataRow>(
  excelColumns: TableExcelColumn<TRecord>[] | undefined,
  selected: TRecord[],
) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Exported Table');

  const mappedRows = selected.map(element => flattenObj(element));

  worksheet.columns = excelColumns || [];

  worksheet.addRows(mappedRows);

  excelColumns?.forEach(column => {
    const { key, render } = column;
    if (!render) {
      return;
    }

    const worksheetColumn = worksheet.getColumn(key);
    worksheetColumn.eachCell((cell, rowNumber) => {
      const rowIndex = rowNumber - 2;
      if (rowIndex < 0) {
        return;
      }

      const row = selected[rowIndex];
      // eslint-disable-next-line no-param-reassign
      cell.value = (!!row && render(_.get(row, key), row, rowIndex, selected)) || '-';
    });
  });

  worksheet.columns.forEach(column => {
    let maxLength = 0;
    if (column.eachCell) {
      column.eachCell({ includeEmpty: true }, cell => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      // eslint-disable-next-line no-param-reassign
      column.width = maxLength < 10 ? 10 : maxLength;
    }
  });

  const xlsxBuffer = await workbook.xlsx.writeBuffer();

  downloadXlsx({
    tableExport: {
      blob: new Blob([xlsxBuffer], {
        type: `data:${FileType.xlsx};`,
      }),
    },
  });
};
